<template>
  <div class="label-list">
    <div
      v-for="item in options"
      :key="item.id"
      :class="['label-item', { 'is-active': value === item.id }]"
      :style="{ backgroundColor: item.color }"
      @click="changeLabel(item)"
    >
      <div>{{ item.label }}</div>
      <div class="label-btn" v-if="isEdit">
        <i class="el-icon-delete" @click.stop="deleteLabel(item)"></i>
      </div>
    </div>
    <div v-if="isEdit && options.length < 10">
      <el-input
        v-model.trim="addValue"
        style="width: 100%;"
        maxlength="6"
        placeholder="新增标签"
      >
        <el-button plain round size="small"
          type="primary"
          slot="append"
          icon="el-icon-upload2"
          @click="appendValue()"
        ></el-button>
      </el-input>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      colors: [
        "#FF3B30",
        "#FF9500",
        "#FFD60A",
        "#34C759",
        "#00E676",
        "#00FFD1",
        "#00BFFF",
        "#007AFF",
        "#5856D6",
        "#AF52DE",
        "#FF2D55",
        "#FF6F00",
        "#FFAB00",
        "#76FF03",
        "#18FFFF",
        "#40C4FF",
        "#7C4DFF",
        "#E040FB",
        "#F50057",
        "#FF4081"
      ],
      addValue: "",
      value: null,
      options: []
    };
  },
  methods: {
    getNextColor() {
      const optionColors = this.options.map(item => item.color);
      for (var i = 0; i < this.colors.length; i++) {
        if (!optionColors.includes(this.colors[i])) {
          return this.colors[i];
        }
      }
    },
    editLabel(item) {},
    deleteLabel(item) {
      this.options = this.options.filter(i => i.id !== item.id);
      // this.options = this.options.map((i, index) => {
      //   return {
      //     ...i,
      //     id: index + 1
      //   };
      // });
      this.value = null;
      this.$emit("change", null);
      this.$emit("optionsChange", this.options);
    },
    changeLabel(item) {
      if (item) {
        return new Promise((resolve, reject) => {
          this.value = item.id;
          this.$emit("change", item);
          setTimeout(() => {
            resolve();
          }, 200);
        });
      }
    },
    // 设置选项
    setOptions(options) {
      this.options = options;
      this.$emit("optionsChange", this.options);
    },
    appendValue() {
      if (!this.addValue) return;
      // 去除首尾空格
      const value = this.addValue.trim();
      // 判断是否重复（按 label）
      const exists = this.options.some(item => item.label === value);
      if (exists) {
        Message.warning("标签已存在，请勿重复添加");
        return;
      }
      const color = this.getNextColor();
      const ids = this.options.map(item => item.id);
      let i = 1;
      while (ids.includes(i)) i++;
      this.options.push({
        label: this.addValue,
        id: i,
        color
      });
      this.addValue = "";
      this.$emit("optionsChange", this.options);
    }
  }
};
</script>
<style scoped>
.label-list {
  padding: 12px 12px 0 20px;
}
.label-item {
  padding: 8px;
  margin-bottom: 8px;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: space-between;
}
.label-item.is-active {
  outline: 2px solid #409eff;
}
.label-item.is-active:after {
  content: "";
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 12px solid #409eff;
}
</style>



// WEBPACK FOOTER //
// src/components/LabelSelect.vue